import { NgModule } from '@angular/core';
import { CollapseModule } from 'ngx-bootstrap/collapse';
import { PopoverModule } from 'ngx-bootstrap/popover';
import { ReactiveFormsModule, FormsModule } from '@angular/forms';
import { NgxDatatableModule } from '@swimlane/ngx-datatable';
import { CommonModule } from '@angular/common';
import { AccordionModule } from 'ngx-bootstrap/accordion';

import { OrderDetailsComponent } from './order-details/order-details.component';
import { OrderMainBookerComponent } from './order-main-booker/order-main-booker.component';
import { CollapsibleCardComponent } from './collapsible-card/collapsible-card.component';
import { PassengerDetailsComponent } from './passenger-details/passenger-details.component';
import { ShoppingCartComponent } from './shopping-cart/shopping-cart.component';
import { FooterComponent } from './footer/footer.component';
import { FlightDetailsComponent } from './flight-details/flight-details.component';
import { FlightLegComponent } from './flight-leg/flight-leg.component';
import { FlightConnectorHorizontalComponent } from './flight-connector-horizontal/flight-connector-horizontal.component';
import { FlightSegmentDetailsComponent } from './flight-segment-details/flight-segment-details.component';
import { FlightSegmentComponent } from './flight-segment/flight-segment.component';
import { FullscreenLoaderComponent } from './fullscreen-loader/fullscreen-loader.component';
import { LoaderComponent } from './loader/loader.component';
import { OrderSearchFormComponent } from './order-search-form/order-search-form.component';
import { OrdersTableComponent } from './orders-table/orders-table.component';
import { SharedModule } from '@shared/shared.module';
import { ErrorModalComponent } from './error-modal/error-modal.component';
import { HeaderModule } from './header/header.module';
import { NavigateBackBtnComponent } from './navigate-back-btn/navigate-back-btn.component';
import { NavigateNextBtnComponent } from './navigate-next-btn/navigate-next-btn.component';
import { FlightSegmentConditionsModalComponent } from './flight-segment-conditions-modal/flight-segment-conditions-modal.component';
import { ErrorPageComponent } from './error-page/error-page.component';
import { BookedFareComponent } from './booked-fare/booked-fare.component';
import { SearchFromModalComponent } from './search-from-modal/search-from-modal.component';
import { SearchFormComponent } from './search-form/search-form.component';
import { LegSearchComponent } from './leg-search/leg-search.component';
import { SortingComponent } from './sorting/sorting.component';
import { FlightTimeAndDateOverviewComponent } from './flight-time-and-date-overview/flight-time-and-date-overview.component';
import { StepperBarComponent } from './stepper-bar/stepper-bar.component';
import { PassengerDetailsOverviewComponent } from '../../pages/extras-page/passenger-details/passenger-details.component';
import { PassengersTotalComponent } from '@pages/extras-page/passengers-total/passengers-total.component';
import { AccordionCustomComponent } from './accordion-custom/accordion-custom.component';
import { SnackBarComponent } from './snackbar/snack-bar.component';
import { FlightOverviewComponent } from './flight-overview/flight-overview.component';
import { FlightTimeAndDateOverviewOrderComponent } from './flight-overview/flight-time-and-date-overview-order/flight-time-and-date-overview.-ordercomponent';
import { FlightConnectorComponent } from './flight-overview/flight-connector/flight-connector.component';
import { FlightCardComponent } from './flight-overview/flight-card/flight-card.component';
import { BundleFareCommonOrderComponent } from './bundle-fare-common-order/bundle-fare-common-order.component';
import { MainBookerCommonOrderComponent } from './main-booker-common-order/main-booker-common-order.component';
import { CommonShoppingCartComponent } from './common-shopping-cart/common-shopping-cart.component';
import { ManagmentOptionsComponent } from './managment-options/managment-options.component';
import { PrimaryButtonComponent } from './buttons/primary-button/primary-button.component';
import { CancelButtonComponent } from './buttons/cancel-button/cancel-button.component';
import { IconButtonComponent } from './buttons/icon-button/icon-button.component';
import { InfoAlertComponent } from './info-alert/info-alert.component';

@NgModule({
  imports: [
    SharedModule,
    CollapseModule,
    HeaderModule,
    PopoverModule,
    FormsModule,
    ReactiveFormsModule,
    NgxDatatableModule,
    CommonModule,
    AccordionModule.forRoot(),
  ],
  declarations: [
    OrderDetailsComponent,
    OrderMainBookerComponent,
    CollapsibleCardComponent,
    PassengerDetailsComponent,
    ShoppingCartComponent,
    FooterComponent,
    FlightDetailsComponent,
    FlightLegComponent,
    FlightConnectorHorizontalComponent,
    FlightSegmentDetailsComponent,
    FlightSegmentComponent,
    FullscreenLoaderComponent,
    LoaderComponent,
    OrderSearchFormComponent,
    OrdersTableComponent,
    ErrorModalComponent,
    NavigateBackBtnComponent,
    NavigateNextBtnComponent,
    FlightSegmentConditionsModalComponent,
    ErrorPageComponent,
    BookedFareComponent,
    SearchFormComponent,
    ManagmentOptionsComponent,
    SearchFromModalComponent,
    StepperBarComponent,
    LegSearchComponent,
    SortingComponent,
    FlightTimeAndDateOverviewComponent,
    PassengerDetailsOverviewComponent,
    PassengersTotalComponent,
    AccordionCustomComponent,
    SnackBarComponent,
    FlightOverviewComponent,
    FlightTimeAndDateOverviewOrderComponent,
    FlightConnectorComponent,
    FlightCardComponent,
    BundleFareCommonOrderComponent,
    MainBookerCommonOrderComponent,
    CommonShoppingCartComponent,
    PrimaryButtonComponent,
    CancelButtonComponent,
    IconButtonComponent,
    InfoAlertComponent,
  ],
  exports: [
    ReactiveFormsModule,
    OrderDetailsComponent,
    OrderMainBookerComponent,
    CollapsibleCardComponent,
    PassengerDetailsComponent,
    ShoppingCartComponent,
    FooterComponent,
    FlightDetailsComponent,
    FlightLegComponent,
    FlightConnectorHorizontalComponent,
    FlightSegmentDetailsComponent,
    FlightSegmentComponent,
    FullscreenLoaderComponent,
    LoaderComponent,
    OrderSearchFormComponent,
    OrdersTableComponent,
    ErrorModalComponent,
    HeaderModule,
    NavigateBackBtnComponent,
    NavigateNextBtnComponent,
    FlightSegmentConditionsModalComponent,
    ErrorPageComponent,
    BookedFareComponent,
    ManagmentOptionsComponent,
    SearchFormComponent,
    SearchFromModalComponent,
    StepperBarComponent,
    LegSearchComponent,
    SortingComponent,
    FlightTimeAndDateOverviewComponent,
    PassengerDetailsOverviewComponent,
    PassengersTotalComponent,
    AccordionCustomComponent,
    SnackBarComponent,
    FlightOverviewComponent,
    FlightTimeAndDateOverviewOrderComponent,
    FlightConnectorComponent,
    FlightCardComponent,
    BundleFareCommonOrderComponent,
    MainBookerCommonOrderComponent,
    CommonShoppingCartComponent,
    PrimaryButtonComponent,
    CancelButtonComponent,
    IconButtonComponent,
    InfoAlertComponent,
  ],
})
export class ComponentsModule {}
